import { axiosInstance, handleAxiosResponse } from "../../../core/sources/network";

import { handleError, showSuccess } from "../../app-messages";
import { getAppStoreCurrentState } from "../../../store";
import { CompanyProfileFeature } from "../../company-profile";
import { actions } from "../slice";

export const subscribeToLite = ({ billingCycle }) => {
  return async (dispatch) => {
    try {
      const { companyProfile } = getAppStoreCurrentState();

      const response = await axiosInstance.put(`/subscriptions/${companyProfile.stripeCustomerId}/lite`, {
        companyId: companyProfile.id,
        billingCycle,
      });

      const { data: subscription, message } = handleAxiosResponse(response);

      CompanyProfileFeature.updateCurrentPlan({ plan: subscription.plan })(dispatch);

      dispatch(actions.setSubscription({ subscription }));
      dispatch(showSuccess(message));
    } catch (error) {
      handleError(error?.response?.data?.message ?? error.message)(dispatch);
    }
  };
};
